import { Table, message, Button, Row, Col, Pagination, Image } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchProps from "../../../component/SearchProps";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";

export default function CategoryBlogManage() {
  const [categories, setCategories] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  const fetchCategories = async () => {
    await axiosInstance.get(`/category-blog/getAll`, {params: pagination})
      .then((res) => {
        const data = res?.data;
        setCategories(data);
      })
      .catch(() => message.error("Error server!"));
  };

  useEffect(() => {
    fetchCategories();
  }, [pagination]);

  const columns = [
    {
      title: <div>ID</div>,
      key: "category_blog_id",
      dataIndex: "category_blog_id",
      width: 100,
      sorter: (a, b) => a.category_blog_id - b.category_blog_id,
      render: (_, record) => <div>{record?.category_blog_id}</div>,
    },
    {
      title: <div>Tên</div>,
      key: "category_blog_name",
      dataIndex: "category_blog_name",
      width: 150,
      ...SearchProps("category_blog_name"),
      render: (_, record) => <div>{record?.category_blog_name}</div>,
    },
    {
      title: <div>Ảnh</div>,
      key: "category_blog_image",
      dataIndex: "category_blog_image",
      width: 150,
      render: (_, record) => <div><Image src={record?.category_blog_image} width={100} height={100}/></div>,
    },
    {
      title: <div className={"base-table-cell-label "}>Ngày tạo</div>,
      key: "create_at",
      dataIndex: "create_at",
      width: 100,
      sorter: (a, b) => dayjs(a.create_at) - dayjs(b.create_at),
      render: (_, record) => {
        return (
          <div className={"cursor-pointer text-[14px] font-normal"}>
            <span className={"!inline-block min-w-[100px]"}>
              {dayjs(record?.create_at).format("DD/MM/YYYY")}
            </span>
          </div>
        );
      },
    },
    {
      key: "operation",
      dataIndex: "operation",
      width: 50,
      render: (_, record) => {
        return (
          <Link
            to={`/admin/quan-ly-danh-muc-blog/${record?.category_blog_id}`}
            className={"text-[var(--blue)]"}
          >
            <EditOutlined />
          </Link>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <Row gutter={10} className={"mb-[8px]"}>
          <Col flex={1}>
            <div className={"text-[20px] font-medium"}>Danh mục Blog</div>
          </Col>
          <Col>
            <Link to={"/admin/quan-ly-danh-muc-blog/tao-moi"}>
              <Button type={"primary"} onClick={() => {}}>
                Tạo
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className={"custom-table"}
          dataSource={categories?.data}
          columns={columns}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={categories?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps)=> {
            setPagination({
              page: p,
              pageSize: ps
            })
          }}
        />
      </div>
    </>
  );
}
